import { CrossCircleFilled } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
  shouldShow?: boolean;
  hasFieldErrorState?: (value: boolean) => void;
};

const ErrorIcon = styled(CrossCircleFilled)`
  width: 12px;
  margin-inline-end: 8px;
  fill: ${colors.strawberry100};
`;

const ErrorField = styled.span`
  color: ${colors.strawberry100};
`;

const message = 'errors.missing-field-error-label';

const MissingFieldError: React.FC<Props> = ({ shouldShow = true, hasFieldErrorState }) => {
  useEffect(() => {
    if (hasFieldErrorState && shouldShow) {
      hasFieldErrorState(true);
    }
  }, [hasFieldErrorState, shouldShow]);

  if (!shouldShow) {
    return null;
  }

  return (
    <ErrorField>
      <ErrorIcon />
      <FormattedMessage id={message} />
    </ErrorField>
  );
};

export default MissingFieldError;
